import currencyToSymbolMap from 'currency-symbol-map/map';

export const DEFAULT_CURRENCY_CODE = 'USD';

export const supportedCurrencies = [
  ['USD', 'US Dollar'],
  ['EUR', 'Euro'],
  ['GBP', 'British Pound'],
  ['JPY', 'Japanese Yen'],
  ['CAD', 'Canadian Dollar'],
  ['AUD', 'Australian Dollar'],
  ['CHF', 'Swiss Franc'],
  ['CNY', 'Chinese Yuan'],
  ['HKD', 'Hong Kong Dollar'],
  ['NZD', 'New Zealand Dollar'],
  ['SEK', 'Swedish Krona'],
  ['NOK', 'Norwegian Krone'],
  ['DKK', 'Danish Krone'],
  ['PLN', 'Polish Zloty'],
  ['CZK', 'Czech Koruna'],
  ['HUF', 'Hungarian Forint'],
  ['RON', 'Romanian Leu'],
  ['BGN', 'Bulgarian Lev'],
  ['ISK', 'Icelandic Krona'],
  ['TRY', 'Turkish Lira'],
  ['BRL', 'Brazilian Real'],
  ['MXN', 'Mexican Peso'],
  ['ZAR', 'South African Rand'],
  ['INR', 'Indian Rupee'],
  ['KRW', 'South Korean Won'],
  ['SGD', 'Singapore Dollar'],
  ['THB', 'Thai Baht'],
  ['IDR', 'Indonesian Rupiah'],
  ['MYR', 'Malaysian Ringgit'],
  ['PHP', 'Philippine Peso'],
  ['ILS', 'Israeli Shekel'],
];

export const supportedCurrencyCodes = supportedCurrencies.map(([code]) => code);

const cleanCurrencyCode = value =>
  String(value || '')
    .trim()
    .toUpperCase();

export const normalizeCurrencyCode = (
  value,
  defaultCurrency = DEFAULT_CURRENCY_CODE
) => {
  const normalizedDefault = cleanCurrencyCode(defaultCurrency);
  const fallback = supportedCurrencyCodes.includes(normalizedDefault)
    ? normalizedDefault
    : DEFAULT_CURRENCY_CODE;
  const candidate = cleanCurrencyCode(
    value || defaultCurrency || DEFAULT_CURRENCY_CODE
  );
  return supportedCurrencyCodes.includes(candidate) ? candidate : fallback;
};

export const currencyOptions = supportedCurrencies.map(([code, name]) => ({
  label: `${code} (${currencyToSymbolMap[code] || code}) - ${name}`,
  value: code,
}));

export const currencyColumnOptions = supportedCurrencies.map(([code]) => ({
  label: `${currencyToSymbolMap[code] || code} ${code}`,
  value: code,
}));

export const currencyOptionFor = (
  value,
  defaultCurrency = DEFAULT_CURRENCY_CODE
) => {
  const code = normalizeCurrencyCode(value, defaultCurrency);
  return currencyOptions.find(option => option.value === code);
};
